import { Box, Divider, Paper } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { styled } from '@material-ui/styles';
import * as React from 'react';
import { div, getQueryParam } from '../common';
import { Flex } from '../flex';
import { Link } from '../link';
import { ColorBar, TileLabel } from './tilesList';
var HeaderTileTitle = styled('div')({
    marginTop: 4,
    marginBottom: 4,
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: 22,
    fontWeight: 500,
});
export var PageTileField = function (_a) {
    var label = _a.label, children = _a.children, $checked = _a.$checked;
    return React.createElement(PageTileFieldRoot, { className: $checked ? ('selection' + ($checked.value ? ' checked' : '')) : '', onClick: $checked && $checked.true },
        React.createElement(TileLabel, null,
            " ",
            label,
            " "),
        React.createElement(PageTileValue, null,
            " ",
            children,
            " "));
};
var PageTileFieldRoot = div({
    display: 'flex',
    flexDirection: 'column',
    minWidth: 100,
    padding: 4,
    margin: 4,
    borderWidth: 1,
    borderRadius: 3,
    '&.selection': {
        cursor: 'pointer',
        '&.checked': {
            backgroundColor: '#fff8e5',
            borderStyle: 'solid',
            borderColor: 'rgb(255, 188, 0)',
        }
    }
});
var PageTileValue = styled('div')({
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 500,
});
export var PageHeaderTile = function (_a) {
    var _b = _a.color, color = _b === void 0 ? null : _b, _c = _a.noPaper, noPaper = _c === void 0 ? false : _c, _d = _a.right, right = _d === void 0 ? undefined : _d, children = _a.children, _e = _a.title, title = _e === void 0 ? null : _e, _f = _a.toolbar, toolbar = _f === void 0 ? null : _f, _g = _a.returnLink, returnLink = _g === void 0 ? null : _g;
    var returnUrl = getQueryParam('returnUrl');
    return (React.createElement(MaybePaper, { noPaper: noPaper },
        React.createElement(Box, { display: "flex", flexDirection: "row", p: 2, pb: 1 },
            color ? React.createElement(ColorBar, { color: color }) : null,
            React.createElement(Box, { ml: 1, display: "flex", flexDirection: "column" },
                title &&
                    React.createElement(HeaderTileTitle, null,
                        returnLink &&
                            React.createElement(PageReturnLink, null,
                                React.createElement(Link, { href: returnUrl || returnLink },
                                    React.createElement(ArrowBackIcon, null),
                                    " Back")),
                        title),
                React.createElement(Flex, { row: true, wrap: true }, children)),
            right ? React.createElement(React.Fragment, null,
                React.createElement(Flex, { grow: true }),
                React.createElement(Flex, { center: true }, right)) : null),
        toolbar ? React.createElement(React.Fragment, null,
            React.createElement(Divider, null),
            toolbar) : null));
};
var MaybePaper = function (_a) {
    var noPaper = _a.noPaper, children = _a.children;
    return noPaper ? children : React.createElement(Paper, null, children);
};
var PageReturnLink = styled('div')({
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 4,
});
//# sourceMappingURL=page-tile.js.map